<template>
  <div id="team">
    <v-container grid-list-xl :fluid="$vuetify.breakpoint.smAndDown">
      <v-layout align-center justify-space-around column>
        <v-flex :mb-5="$vuetify.breakpoint.mdAndUp">
          <p
            class="
              font-weight-medium
              blue-grey--text
              text--darken-4
              headline
              text-center
              subheaders
            "
          >
            <span class="logoText"> R E T H Y M O S</span> is a firm of
            consultants providing services to start-ups, scale-ups and
            established organizations in the financial and technology
            industries, both on a strategic and execution level.
          </p>
          <br />
          <hr />
          <p id="teamIntro" class="title font-weight-light pa-3">
            We assist clients with business strategy, sales and marketing,
            technology evaluation and selection, process engineering, business
            and systems development. The principals have an extensive network
            across all major financial centers. We deliver a practical and very
            much boots on the ground approach in our mandates as we are always
            focused on growing the business of our clients in the most direct
            way possible.
          </p>
        </v-flex>
        <v-flex
          :ma-5="$vuetify.breakpoint.mdAndUp"
          v-for="(person, i) in teamMembers"
          :key="i"
        >
          <v-card class="bioTitleCard">
            <v-card-title class="bioTitle">
              <span>
                {{ person.name }}
              </span>
              <v-spacer class="hidden-sm-and-down"></v-spacer>
              <div id="titles">
                <v-chip class="black white--text">{{ person.brief }} </v-chip>
                <v-chip color="#18519a" class="white--text">{{
                  person.education
                }}</v-chip>
              </div>
            </v-card-title>
          </v-card>
          <v-card flat class="personalBio">
            <v-layout
              row
              align-center
              justify-space-between
              :column="$vuetify.breakpoint.smAndDown"
            >
              <v-flex :offset-xs1="$vuetify.breakpoint.mdAndUp">
                <v-img
                  class="profilePic"
                  height="350px"
                  width="250px"
                  :src="person.photo"
                ></v-img>
              </v-flex>
              <v-flex pa-4>
                <p class="bio blue-grey--text text--darken-4 subheading">
                  {{ person.bio }}
                </p>
              </v-flex>
              <v-flex xs1></v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      teamMembers: [
        {
          name: "Jacob Woo",
          brief: "Associate",
          photo: "jacob.jpg",
          bio: "Jacob is keen on building a successful career at the intersection of business and technology. With a niche combination of degrees in Business Management and Computer Science, he has hands-on experience with Business Development, Marketing, Digital Transformation, and Information Technology for both startups and multinational corporations in an international sphere spanning Korea, Taiwan, and Hong Kong. Jacob has proven himself to be a valuable asset, creatively devising strategic business and growth initiatives and leading digital technology implementations and cyber risk advisory projects across various business verticals.",
          education: "Business and System Analysis",
        },
        {
          name: "Doris Chan",
          brief: "Managing Partner",
          photo: "doris.jpg",
          bio: "Doris is a solicitor qualified in England and Wales as well as Hong Kong, with 15+ years post-qualification experience. She is a former senior counsel in the Hong Kong Monetary Authority, with expertise in bank crisis management and resolution, prudential regulatory regime and general commercial law. She is also an experienced corporate finance and transaction lawyer. Through her private practice in international law firms, she has gained extensive experience in ECM deals, IPOs, mergers, acquisitions, private equity investments, joint ventures, cross-border transactions and corporate governance. ",
          education: "Strategic Consulting",
        },
        {
          name: "Guido Glowania",
          brief: "Managing Partner",
          photo: "gui.jpeg",
          bio: "Guido is former Director for professional trading services with Merrill Lynch in Asia Pacific. He started his 20+ year career in the finance industry as a broker at Bache Securities and has held sales executive and business analysis positions with Instinet and Orc Software. Guido holds FINRA Series 7, 3, 55, 63, 4 and 24. He has advised global exchanges, financial intermediaries, technology providers, infrastructure operators and startups on business development and strategy in all major financial centers.",
          education: "Business Development and Strategy",
        },
      ],
    };
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Rajdhani");
@import url("https://fonts.googleapis.com/css?family=Play");

#team {
  padding-top: 7%;
}

.bio {
  line-height: 1.6 !important;
  padding: 10px 10px;
}

#teamIntro {
  padding: 15px 10px;
  text-indent: 3em;
  line-height: 1.6 !important;
}

.personalBio {
  border-top: solid 3px black;
  background-color: #f0f0f0;
}

.bioTitleCard {
  font-family: "Rajdhani", sans-serif;
  font-weight: bold;
  font-size: 20px;
}

.bioTitle {
  display: flex;
  justify-content: space-between;
}

.profilePic {
  border: solid 3px black;
  border-radius: 1px;
  margin: 30px 0px;
}
</style>